module.exports = __webpack_public_path__ + "img/cboi-cru.28fc0b5.png";